(ns ui.components.input.textarea
  (:require
   [cljs-uuid-utils.core :as uuid]
   [common.util :as cu]
   [ui.util :as uu]
   [oops.core :as oops]
   [reagent.core :as r]
   [ui.dom-globals :as dg]))

(def PADDING_TOP 8)
(def PADDING_BOTTOM 8)

(defn autosize
  [dom-node]
  (when-let [style (aget dom-node "style")]
    (aset style "height" "auto")
    (aset style
          "height"
          (str (+ (aget dom-node "scrollHeight")
                  PADDING_TOP
                  PADDING_BOTTOM)
               "px"))))

(defn view
  [{:keys [_value _class _variant _transparent? _placeholder _disabled? auto-focus?
           _on-change _full-width? _on-focus _on-blur]}]
  (let [local-state (r/atom {})
        uuid (uuid/uuid-string (uuid/make-random-uuid))]
    (r/create-class
     {:component-did-mount
      (fn []
        (when-let [dom-node (:dom-node @local-state)]
          (autosize dom-node)
          (when auto-focus?
            (.focus dom-node))))
      :reagent-render
      (fn [{:keys [value class variant transparent? placeholder disabled?
                   on-change full-width? on-focus on-blur]}]
        (let [{:keys [selection-start selection-end]} @local-state]
          [:textarea
           ;; Vertical padding via inline style so PADDING_TOP/BOTTOM stay the single
           ;; source of truth shared with autosize's height math (Tailwind can't read
           ;; runtime-interpolated class names).
           (merge {:style {:padding-top    (str PADDING_TOP "px")
                           :padding-bottom (str PADDING_BOTTOM "px")}
                   :class (uu/cm "peer mb-0 min-h-28 px-3 max-h-[80vh]"
                                 "text-input-light-text disabled:text-disabled-regular-text"
                                 "text-sm placeholder-transparent"
                                 "focus:outline-none focus:ring-0"
                                 "rounded resize-y"
                                 (if transparent?
                                   "bg-transparent disabled:bg-transparent"
                                   "text-input-light-text disabled:text-disabled-regular-text
                                          bg-input-light disabled:bg-disabled-regular ")
                                 (when full-width?
                                   "w-full")
                                 (if (not= variant :borderless)
                                   "border border-input-light-border-paler hover:border-input-light-border focus:border-input-light-border"
                                   "border-none focus:border-transparent")
                                 (when-not (cu/blank-value? value)
                                   "value")
                                 class)
                   :placeholder (or placeholder "")
                   :id          uuid
                   :ref         (fn [input-ref]
                                  (when input-ref
                                    (when (:focused? @local-state)
                                      (oops/ocall input-ref "setSelectionRange" selection-start selection-end))
                                    (swap! local-state assoc :dom-node input-ref)))
                   :value       (or (:temp-value @local-state)
                                    value "")
                   :on-focus    (fn [_e]
                                  (swap! local-state assoc :focused? true)
                                  (when (fn? on-focus)
                                    (on-focus)))
                   :on-blur     (fn [e]
                                  (swap! local-state assoc :temp-value nil)
                                  (when (fn? on-blur)
                                    (on-blur (dg/event-target-value e))))
                   :on-change   (fn [e]
                                  (let [value (dg/event-target-value e)
                                        target (dg/target e)]
                                    (when (:dom-node @local-state)
                                      (swap! local-state assoc
                                             :selection-start (aget target "selectionStart")
                                             :selection-end (aget target "selectionEnd")))
                                    (cond (fn? on-change)
                                          (on-change value)
                                          :else
                                          (swap! local-state assoc :temp-value value))))}
                  (when disabled?
                    {:disabled true}))]))})))
